import { render, staticRenderFns } from "./dialog-model.vue?vue&type=template&id=55524a82&scoped=true&"
var script = {}
import style0 from "./dialog-model.vue?vue&type=style&index=0&id=55524a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55524a82",
  null
  
)

export default component.exports